import React from 'react'
import styles from './facsimileGroup.module.scss'

const HoneyPotLink = () => {
  const pushToDataLayer = (data) => {
    if (typeof window === 'undefined') return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
  }

  const handleLinkClick = () => {
    pushToDataLayer({
      event: 'traffic_check',
      traffic_type: 'bot',
    })
  }
  return (
    <a className={styles.facsimileNpcLink} href='/facsimile-npc' onClick={handleLinkClick}>
      fax
    </a>
  )
}

export default HoneyPotLink
